import type { Account, AccountEdit, AccountLicencedEdit, AccountsHeader, Note, Tag } from 'pages/Admin/UsersAdministration/types';
import type { BasicSuccessResponse, HTTPFunctions } from './types';
import type { AdminSubscription, Licence } from 'pages/Admin/SubscriptionById/types';
import type { ResponseDocumentInsight } from 'pages/Admin/DocumentsInsight/Table/types';

const adminAccounts = ({ get, post, put, del, getPDF }: HTTPFunctions) => ({
  addAccount: (data: AccountEdit) => post<Account>("/users/", data),
  addAccountLicenced: (data: AccountLicencedEdit) => post<Licence>("/users/licence/", data),
  getheaders: () => get<AccountsHeader>("/users/info/accounts"),
  listAccounts: () => get<Account[]>("/users/info"),
  getSubscriptions: () => get<AdminSubscription[]>("/subscriptions"),
  getSubscriptionById: (id: string) => get<AdminSubscription>(`/subscriptions/${id}`),
  resetCreditsAll: () => put<BasicSuccessResponse>('/credits/reset/all', {}),
  resetCreditsUpdateAll: (credits: number) => put<BasicSuccessResponse>(`/credits/all?credits_to=${credits}`, {}),
  resetCreditsSubscriptionById: (subscriptionId: string) => put<BasicSuccessResponse>(`/credits/reset/subscription/${subscriptionId}`, {}),
  resetCreditsUpdateById: (subscriptionId: string, credits: number) => put<BasicSuccessResponse>(`/credits/${subscriptionId}?credits_to=${credits}`, {}),
  resetCreditsLicenceById: (licenceId: number) => put<BasicSuccessResponse>(`/credits/reset/licence/${licenceId}`, {}),
  resetCreditsUpdateLicenceById: (licenceId: string, credits: number) => put<BasicSuccessResponse>(`/credits/licence/${licenceId}?credits_to=${credits}`, {}),
  delAccountById: (id: string) => del<BasicSuccessResponse>(`/accounts/${id}`),
  delUserById: (id: number) => del<BasicSuccessResponse>(`/users/${id}`),
  downloadUserInsight: () => get<ResponseDocumentInsight>(`/users/insights`),
  downloadUserInsightXLSX: () => getPDF<string>(`/users/insights/xlsx`),
  updateAccount: (id: number, data: AccountEdit) => put<BasicSuccessResponse>(`/users/user_information/${id}`, data),
  listAllTags: () => get<Tag[]>("/tags/"),
  createTag: (user_id: number, name: string) => post<{tag: Tag}>("/users/tags/", { user_id, name }),
  addUserTag: (user_id: number, tag_id: number) => put<BasicSuccessResponse>("/users/tags/", { user_id, tag_id }),
  listUserTags: (id: number) => get<Tag[]>(`/users/tags/${id}`),
  delUserTagById: (id: number, user_id: number) => del<BasicSuccessResponse>(`/users/tags/${user_id}/${id}`),
  createNote: (user_id: number, note: string) => post<Note>("/users/notes/", { user_id, note }),
  listNotes: (user_id: number) => get<Note[]>(`/users/notes/${user_id}`),
  updateNote: (id: number, note: string) => put<Note>(`/users/notes/${id}`, { note }),
  delNoteById: (id: number) => del<BasicSuccessResponse>(`/users/notes/${id}`),
  addCredits: (user_id: number, credits: number, note: string) =>
    put<BasicSuccessResponse>(`/users/credits/${user_id}`, { credits, note })
});

export default adminAccounts;
